export const LAGO_PLAN_MAP: Record<string, string> = {
  'kegel-l1nw-USD-Monthly': 'kegel-bl-w1m1-usd',
  'kegel-l1ndw-USD-Monthly': 'kegel-bl-disc-w1m1-usd',
  'kegel-l1n-USD-Monthly': 'kegel-bl-m1-usd',
  'kegel-l1nd-USD-Monthly': 'kegel-bl-disc-m1-usd',
  'kegel-l1n-w1-a-USD-Monthly': 'kegel-bl-m1-usd',
  'kegel-l1n-w1-b-USD-Monthly': 'kegel-bl-m1-usd',
  'kegel-l1n-USD-Every-3-months': 'kegel-bl-m3-usd',
  'kegel-l1nd-USD-Every-3-months': 'kegel-bl-disc-m3-usd',

  'kegel_5-USD-Weekly': 'kegel-mail-trial-v1-w1-usd',
  'kegel_5f-USD-Weekly': 'kegel-mail-trial-v2-w1-usd',
  'kegel_6-USD-Weekly': 'kegel-mail-trial-v3-w2w1-usd',
  'kegel_7-USD-Weekly': 'kegel-mail-trial-v4-w2w1-usd',
  'kegel_8-USD-Every-3-months': 'kegel-mail-trial-v5-w2w1-usd',

  'kegel-e2-cw-USD-Every-4-weeks': 'kegel-us-bl-w1w4-usd',
  'kegel-e2-c-USD-Every-4-weeks': 'kegel-us-bl-w4-usd',
  'kegel-e2-c-d-USD-Every-4-weeks': 'kegel-us-bl-disc-w4-usd',
  'kegel-e2-c-USD-Every-12-weeks': 'kegel-us-bl-w12-usd',
  'kegel-e2-c-d-USD-Every-12-weeks': 'kegel-us-bl-disc-w12-usd',
};
